/**
 * Helpers do módulo Solicitações por Categoria.
 */
import { api } from '../services/api';

/** Emojis por categoria oficial (24 categorias). */
export const CATEGORIA_ICONS = {
  'Agronegócio & Produção Local': '🌿',
  'Alimentos & Bebidas': '🍽️',
  'Animais & Pets': '🐾',
  'Arte & Cultura': '🎨',
  'Automotivo': '🚗',
  'Beleza & Estética': '✂️',
  'Compras & Varejo': '🛍️',
  'Construção & Reformas': '🔨',
  'Educação': '📚',
  'Esportes & Atividades': '🏃',
  'Eventos & Festas': '🎉',
  'Imobiliário': '🏠',
  'Indústria & Manufatura': '🏭',
  'Mídia & Comunicação': '📰',
  'Pets & Veterinária': '🐾',
  'Saúde & Bem-estar': '🩺',
  'Serviços': '🔧',
  'Serviços Empresariais': '💼',
  'Serviços Financeiros': '💰',
  'Tecnologia & Telecom': '💻',
  'Terceiro Setor': '🤝',
  'Transporte & Logística': '🚚',
  'Turismo & Lazer': '✈️',
  'Outros': '✨',
};

export function emojiFor(categoria) {
  return CATEGORIA_ICONS[categoria] || '✨';
}

/** Placeholders por categoria para o textarea de descrição. */
export const PLACEHOLDERS = {
  'Serviços': 'Ex: Preciso de eletricista para instalar 3 tomadas no sábado',
  'Construção & Reformas': 'Ex: Preciso de pedreiro para reforma do banheiro até segunda',
  'Beleza & Estética': 'Ex: Procuro manicure disponível esta semana para unhas em gel',
  'Saúde & Bem-estar': 'Ex: Procuro fisioterapeuta para sessões 2x por semana',
  'Educação': 'Ex: Busco professor de reforço de matemática para 2x por semana',
  'Alimentos & Bebidas': 'Ex: Preciso de 50 salgados para evento na sexta-feira',
  'Agronegócio & Produção Local': 'Ex: Preciso de 10kg de queijo artesanal para esta semana',
  'Compras & Varejo': 'Ex: Procuro tênis branco número 38 — entrega rápida',
  'Tecnologia & Telecom': 'Ex: Preciso de quem desenvolva site institucional simples',
  'Eventos & Festas': 'Ex: Procuro DJ para festa de 30 anos no próximo sábado',
  'Automotivo': 'Ex: Preciso de mecânico para revisão completa esta semana',
  'Transporte & Logística': 'Ex: Preciso de frete pequeno bairro X → bairro Y na quinta',
  'Pets & Veterinária': 'Ex: Procuro adestrador para meu cão de 8 meses',
};

export function placeholderFor(categoria) {
  return PLACEHOLDERS[categoria] || 'Ex: Descreva o que você precisa e quando…';
}

/** Lista as 24 categorias oficiais (busca cache local + API se necessário). */
let _cache = null;
export async function fetchCategoriasOficiais() {
  if (_cache) return _cache;
  try {
    const r = await api.get('/categories');
    const items = Array.isArray(r.data) ? r.data : r.data?.items || [];
    _cache = items.map((c) => ({ nome: c.nome, slug: c.slug }));
    return _cache;
  } catch {
    return [];
  }
}

export function statusLabel(status) {
  switch (status) {
    case 'aberta': return { label: 'Aberta', cor: 'bg-green-100 text-green-700', dot: 'bg-green-500 animate-pulse' };
    case 'resolvida': return { label: 'Resolvida', cor: 'bg-green-100 text-green-800', dot: 'bg-green-700' };
    case 'expirada': return { label: 'Expirada', cor: 'bg-gray-200 text-gray-600', dot: 'bg-gray-400' };
    case 'cancelada': return { label: 'Cancelada', cor: 'bg-gray-300 text-gray-700 line-through', dot: 'bg-gray-500' };
    default: return { label: status, cor: 'bg-gray-100 text-gray-600', dot: 'bg-gray-400' };
  }
}

export function expiraTimer(iso) {
  if (!iso) return { label: '', cor: 'text-gray-500' };
  const ms = new Date(iso).getTime() - Date.now();
  if (ms <= 0) return { label: 'Expirada', cor: 'text-gray-500' };
  const horas = ms / (1000 * 60 * 60);
  if (horas < 2) return { label: `Expira em ${Math.max(1, Math.round(ms / 60000))} min`, cor: 'text-red-600 font-bold' };
  if (horas < 24) return { label: `Expira em ${Math.round(horas)}h`, cor: 'text-amber-600' };
  const dias = Math.ceil(horas / 24);
  return { label: `Expira em ${dias} ${dias === 1 ? 'dia' : 'dias'}`, cor: 'text-gray-500' };
}

export function timeAgo(iso) {
  if (!iso) return '';
  const date = new Date(iso);
  const seg = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seg < 60) return 'agora há pouco';
  const min = Math.floor(seg / 60);
  if (min < 60) return `há ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `há ${h}h`;
  const d = Math.floor(h / 24);
  if (d === 1) return 'ontem';
  if (d < 7) return `há ${d} dias`;
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' });
}
